var ActionStyle;
(function (ActionStyle) {
    ActionStyle["BUTTON"] = "button";
    ActionStyle["CHECKBOX"] = "checkbox";
    ActionStyle["DROPDOWN"] = "dropdown";
    ActionStyle["ICON"] = "icon";
    ActionStyle["INLINE_IMAGE"] = "inline-image";
    ActionStyle["OPTION"] = "option";
    ActionStyle["OPTION_GROUP"] = "option-group";
    ActionStyle["TEXT"] = "text";
})(ActionStyle || (ActionStyle = {}));
export { ActionStyle, };
//# sourceMappingURL=action-constants.js.map